import React from 'react'
import { observer } from 'mobx-react'
import Avatar from 'components/Avatar'
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import styles from './PendingMembersTable.sass'
import PendingTeamMembersViewModel, {
  pendingTeamMembersTableColumns,
} from '../PendingTeamMembersViewModel'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: PendingTeamMembersViewModel
}

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'numeric',
  day: '2-digit',
  year: 'numeric',
})

export default observer(function PendingMembersTable({ vm }: Props) {
  const { currentSort, currentSortOrder, setSort, filtered } = vm

  return (
    <div>
      <Table striped stickyHeader>
        <TableHead>
          {pendingTeamMembersTableColumns.map((col) => (
            <TableHeader
              key={col.key}
              canSort={col.sortable}
              sortOrder={col.key === currentSort ? currentSortOrder : 'none'}
              onSort={(newSort) => setSort(col.key, newSort)}
            >
              {col.header}
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>
          {filtered.map((pendingMember) => {
            return (
              <TableRow key={pendingMember.email}>
                <TableCell>
                  <div className={styles.memberItem}>
                    <div>
                      <Avatar
                        size={32}
                        subject={{
                          avatar: pendingMember.avatar,
                          displayName: pendingMember.email,
                        }}
                      />
                    </div>
                    <div className={styles.itemInfo}>
                      <p className={styles.infoSubitle}>
                        {pendingMember.email}
                      </p>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {dateFormatter.format(pendingMember.dateCreated)}
                </TableCell>
                <TableCell>
                  {dateFormatter.format(pendingMember.expires)}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
})
